<template lang="pug">
.upsell-banner
  .upsell-banner-header
    i.hi.hi-lock
    strong
      | {{ feature.upsell_heading }} is a premium feature
  .banner-content
    | {{ feature.upsell_body }}
  .banner-links(v-if="canManageBilling")
    a.btn.btn-primary(
      :href="upgradePremiumLink"
      :disabled="disabled"
      @click="onUpgradeClick"
    )
      | Upgrade your plan
    a(
      href="https://support.hubstaff.com/new-pricing-and-plans/"
      target="_blank"
      rel="noopener noreferrer"
    )
      | Learn more about premium
  .text-lighter(v-else)
    | Ask your owner to upgrade to Premium to enable {{ feature.upsell_heading }} for you.
</template>

<script>
import { OrganizationsResource } from '~/resources';

export default {
  name: 'AppUpsellBanner',
  props: {
    organizationId: Number,
    feature: {
      type: Object,
      required: true,
    },
    canManageBilling: {
      type: Boolean,
      default: false,
    },
    trackClick: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      disabled: false,
    };
  },
  computed: {
    upgradePremiumLink() {
      return OrganizationsResource.plansLink({ id: this.organizationId });
    },
    hasAnalytics() {
      return typeof window.analytics === 'object';
    },
  },
  methods: {
    onUpgradeClick(event) {
      const premiumLink = this.upgradePremiumLink;

      this.disabled = true;
      event.preventDefault();
      if (!this.hasAnalytics || !this.trackClick) {
        location.href = premiumLink;

        return;
      }
      analytics.track(
        'Upgrade mat clicked',
        { source: `${this.feature.id} upgrade mat` },
        {},
        () => (location.href = premiumLink),
      );
      /* Give the analytics callback 2.5 seconds to be called,
         as some environments with analytics disabled have a
         'window.analytics' that does not fire the callback. */
      setTimeout(() => {
        if (location.href !== premiumLink) {
          location.href = premiumLink;
        }
      }, 2500);
    },
  },
};
</script>
